import { render } from "./ApplicationForVacancies.vue?vue&type=template&id=f07f85b8"
import script from "./ApplicationForVacancies.vue?vue&type=script&lang=js"
export * from "./ApplicationForVacancies.vue?vue&type=script&lang=js"

import "./ApplicationForVacancies.vue?vue&type=style&index=0&id=f07f85b8&lang=css"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__